<template>
    <b-card class="card-accent-secondary" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-light fa-file-pen"></i> <strong> Forms </strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <b-card-body>
                <div class="mb-3">
                    <b-button v-if="checkUserPermission('patient', 'can_add')" @click="addNew = !addNew" :variant="addNew ? 'danger' : 'primary'">
                        <i :class="[addNew ? 'fa-solid fa-ban' : 'fa-solid fa-plus']"></i> {{ addNew ? 'Cancel' : 'Add' }}
                    </b-button>
                </div>
                <b-collapse id="add-form" v-model="addNew">
                    <forms-base />
                </b-collapse>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import FormsBase from "./FormsBase"

export default ComponentExtension.extend({
    name: "forms-widget",
    components: {
        FormsBase
    },
    data() {
        return {
            addNew: false
        }
    },
})
</script>
